import Appsignal from "@appsignal/javascript";

export const appsignal = new Appsignal({
  key: `${process.env.REACT_APP_APPSIGNAL_KEY}`,
  revision: "f7af6d39a8af4a10b40f7c06885220d2b896b4f1",
});
